import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
// import styles from './Address.module.scss'
import { useSelector } from 'react-redux'
import { getNestedProperty } from '../../helpers/getNestedProperty';
import { StatusInputWrapper } from '../StatusInputWrapper';

const Apartment = ({ t, reduxAppProperty, changeObjectPropertyAction, validateApartment, apartmentError, apartmentValid, setIsError }) => {
  // const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const apartment = useSelector((state) => getNestedProperty(state.app, reduxAppProperty).apartment)

  const handleApartment = (e) => {
    try {
      let name = e.currentTarget.value
      changeObjectPropertyAction('apartment', name);
      validateApartment(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurApartment = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.trim()
      changeObjectPropertyAction('apartment', name);
      validateApartment(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <StatusInputWrapper
      isValid={apartmentValid}
      errorMsg={apartmentError}
      t={t}
      label={t('current_address.apartment')}
      customClasses={'fw-4'}
      id="Apartment" name="Apartment" type="text"
      isFocussed={isFocussed}
      aria-describedby="apartment"
      onChange={handleApartment}
      onBlur={onBlurApartment}
      onFocus={() => SetIsFocussed(true)}
      value={apartment}
      autoComplete="off"
      maxLength="20"
    />
  )
}

export default withTranslation('common')(Apartment)